<template>
  <div class="container_box">
    <div class="passwordManage_box">
      <div class="flex align-items-center">
        <h2 class="title">{{ $t('key1003941') }}</h2>
        <span class="ml30" :class="setingTalg ? 'setColor': 'notSetColor'">{{ setingText }}</span>
      </div>
      <div class="flex align-items-center">
        <Button class="mr15" type="error" v-if="setingTalg && getPermission('erpCommonSettingParam_deletePaymentPassword')"
          @click="deletePayPasswordModal = true">{{ $t('key1003942') }}</Button>
        <Button type="primary" v-if="getPermission('erpCommonSettingParam_updatePaymentPassword') ||
        getPermission('erpCommonSettingParam_savePaymentPassword')"
          @click="setPayPasswordModal = true">{{ buttonText }}</Button>
      </div>
    </div>
    <!--删除打款密码弹窗-->
    <Modal v-model="deletePayPasswordModal" :title="$t('key1003935')" width="550" :transfer="false" :mask-closable="false"
      class-name="deletePayPasswordStyle" @on-visible-change="deletePayPasswordChange">
      <Form ref="deletePayPasswordForm" :model="deletePayPasswordForm" :label-width="120" :rules="ruleValidatePass" @submit.native.prevent>
        <Row>
          <h2 class="tips_title mb10">{{ $t('key1003943') }}</h2>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003936')" prop="password">
              <Input v-model="deletePayPasswordForm.password" :placeholder="$t('key1003589')"
                type="password" password style="width: 80%;"></Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="deletePayPasswordModal = false">{{ $t('key1000112') }}</Button>
        <Button type="error" @click="deletePayPasswordBtn">{{ $t('key1003942') }}</Button>
      </template>
    </Modal>
    <!--设置、修改打款密码弹窗-->
    <Modal v-model="setPayPasswordModal" :title="setPayPasswordTitle" width="550" :transfer="false" :mask-closable="false"
      class-name="setPayPasswordStyle" @on-visible-change="setPayPasswordChange">
      <Form ref="setPayPasswordForm" :model="setPayPasswordForm" :label-width="120" :rules="ruleValidate" @submit.native.prevent>
        <Row style="width: 90%" v-if="setingTalg">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003936')" prop="oldPassword">
              <Input v-model="setPayPasswordForm.oldPassword" :placeholder="$t('key1003589')" type="password" password></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003937')" prop="password">
              <Input v-model="setPayPasswordForm.password" :placeholder="$t('key1003589')" type="password" password></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003938')" prop="password1">
              <Input v-model="setPayPasswordForm.password1" :placeholder="$t('key1003939')" type="password" password></Input>
            </Form-item>
          </Col>
        </Row>
        <Row style="width: 90%" v-else>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002791')" prop="password">
              <Input v-model="setPayPasswordForm.password" :placeholder="$t('key1003589')" type="password" password></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003940')" prop="password1">
              <Input v-model="setPayPasswordForm.password1" :placeholder="$t('key1003939')" type="password" password></Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="setPayPasswordModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="setPayPasswordBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';

export default {
  name: "passwordManage",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      setingTalg: false,
      setingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003927'),
      buttonText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003928'),
      setPayPasswordModal: false,
      setPayPasswordTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003928'),
      deletePayPasswordModal: false,
      setPayPasswordForm: {
        password: '',
        password1: '',
        oldPassword: ''
      },
      deletePayPasswordForm: {
        password: ''
      },
      ruleValidate: {
        password: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143'),
            trigger: 'blur'
          }
        ],
        oldPassword: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003929'),
            trigger: 'blur'
          }
        ],
        password1: [
          {
            validator: v.validatenewPassword(),
            required: true,
            trigger: 'blur'
          }
        ],
      },
      ruleValidatePass: {
        password: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143'),
            trigger: 'blur'
          }
        ]
      },
      erpCommonSettingParamId: null
    };
  },
  created() {
    this.getSetPassword();
  },
  methods: {
    // 获取密码设置的状态
    getSetPassword() {
      let v = this;
      if (v.getPermission('erpCommonSettingParam_queryPaymentPassword')) {
        v.setingTalg = false;
        v.erpCommonSettingParamId = null;
        v.axios.get(api.get_erpCommonSettingParam_queryPaymentPassword).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data && data.length > 0) {
              data.map((item) => {
                if (item.paramKey == 'paymentPassword') {
                  if (item.paramValue) {
                    v.setingTalg = true;
                    v.erpCommonSettingParamId = item.erpCommonSettingParamId;
                  }
                }
              });
            }
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 删除密码
    deletePayPasswordBtn() {
      let v = this;
      v.$refs['deletePayPasswordForm'].validate((valid) => {
        if (valid) {
          v.axios.delete(api.delete_erpCommonSettingParam + `${v.deletePayPasswordForm.password}`,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.deletePayPasswordModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
              v.getSetPassword();
            }
          });
        }
      });
    },
    // 设置、修改打款密码按钮
    setPayPasswordBtn() {
      let v = this;
      let url = '';
      let method = '';
      let text = '';
      let query = null;
      v.$refs['setPayPasswordForm'].validate((valid) => {
        if (valid) {
          // 更换打款密码
          if (v.setingTalg) {
            url = api.post_erpCommonSettingParam_updatePaymentPassword;
            text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003930');
            method = 'post';
            query = {
              erpCommonSettingParamId: v.erpCommonSettingParamId,
              newPassword: v.setPayPasswordForm.password,
              oldPassword: v.setPayPasswordForm.oldPassword
            };
          }
          // 保存打款密码
          else {
            url = api.put_erpCommonSettingParam_savePaymentPassword + `${v.setPayPasswordForm.password}`;
            text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003931');
            method = 'put';
          }
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.setPayPasswordModal = false;
              v.$Message.success(text);
              v.getSetPassword();
            }
          });
        }
      });
    },
    // 监听设置打款密码弹窗
    setPayPasswordChange(value) {
      if (!value) {
        this.$refs['setPayPasswordForm'].resetFields();
      }
    },
    // 监听删除打款密码弹窗
    deletePayPasswordChange(value) {
      if (!value) {
        this.$refs['deletePayPasswordForm'].resetFields();
      }
    },
    // 校验新密码与旧密码
    validatenewPassword() {
      let v = this;
      let password = function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003589')));
        } else if (v.setPayPasswordForm.password !== value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003932')));
        } else {
          callback();
        }
      };
      return password;
    },
  },
  watch: {
    setingTalg: {
      handler(value) {
        let v = this;
        if (value) {
          v.setingText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003933');
          v.buttonText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003934');
          v.setPayPasswordTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003934');
        } else {
          v.setingText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003927');
          v.buttonText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003928');
          v.setPayPasswordTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003928');
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.passwordManage_box {
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    color: #333;
    font-size: 16px;
    font-weight: bold;
  }

  .notSetColor {
    color: #EF1F12;
  }

  .setColor {
    color: #3ad119;
  }
}

.deletePayPasswordStyle {
  .tips_title {
    color: #333;
    padding-left: 24px;
    font-size: 14px;
  }
}
</style>